import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { getReadableAccessLevel } from '../access-control/utils';

export default function AccessControlModal({
  showConfirmModal,
  handleCancelAccessChange,
  handleConfirmAccessChange,
  pendingAccessChange,
}) {
  const isNoAccess = pendingAccessChange?.newType === 'No Access';

  return (
    <Modal show={showConfirmModal} onHide={handleCancelAccessChange} className="user-access-confirm-modal">
      <Modal.Header closeButton>
        <Modal.Title>Confirm Access Change</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to change all camera access to{' '}
        {pendingAccessChange?.newType
          ? getReadableAccessLevel(pendingAccessChange.newType)
          : ''}?
        This will affect all cameras for this user.
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-brand-outline btn-compact" onClick={handleCancelAccessChange}>
          Cancel
        </Button>
        <Button
          className={isNoAccess
            ? 'btn-brand-outline btn-compact access-control-btn-danger'
            : 'btn-brand-dark btn-compact'}
          onClick={handleConfirmAccessChange}
        >
          Confirm Change
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
